// routes/providerTypes.ts

import { DeepPartial } from "react-hook-form";
import { PathsShape } from "./makePaths";
export const ROOTS = {
  AUTH: "/auth",
  PLAYER: "/player",
  TOURNAMENT: "/tournament",
  SPORTPROVIDER: "/sportprovider",
  AUTH_DEMO: "/auth-demo",
  DASHBOARD: "/dashboard",
};

// routes/providerTypes.ts
export type ProviderType = "organiser" | "facility" | "camp" | "coach";
export const BASES: Record<ProviderType, string> = {
  organiser: "organiser",
  facility: "",
  coach: "",
  camp: "camp",
};

// routes/makePaths.ts (continued)
export const OVERRIDES = {
  organiser: {
    // only override what differs; leave the rest out
    settings: {
      root: `${ROOTS.DASHBOARD}/organiser/settings`,
      global: `${ROOTS.DASHBOARD}/organiser/settings/global`,
      // if you also need prefixed others later, just add them
      // pricing: `${ROOTS.DASHBOARD}/organiser/settings/pricing`,
      // venue: { root: `${ROOTS.DASHBOARD}/organiser/settings/venue` }
    },
  },
  // camp: { …optional overrides… }
} satisfies Partial<Record<ProviderType, DeepPartial<PathsShape>>>;
